module.exports = __webpack_public_path__ + "static/media/knorr.e520d632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/knorr.png
// module id = 962
// module chunks = 0